<template>
    <div v-if="log">
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-11">
                    <simulation :registration="registration" :simulation="simulation"></simulation>
                    <log-content
                        :log="log"
                        :registration="registration"
                        :simulation="simulation"
                        :types="types"
                        :competencies="competencies"
                        :grid-competencies="gridCompetencies"
                        :lang="registration.degree.lang"
                        :filters="filters"
                        @filtersChanged="filters = $event"
                    ></log-content>
                </div>
                <div class="col-1">
                    <features
                        :log="log"
                        :registration="registration"
                        :simulation="simulation"
                        :lang="registration.degree.lang"
                        :competencies="competencies"
                        :grid-competencies="gridCompetencies"
                        :types="types"
                        :filters="filters"
                        @filtersChanged="filters = $event"
                    ></features>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Simulation from './log/Simulation'
    import LogContent from './log/LogContent'
    import Features from './log/GlobalFeatures'

    export default {

        components: {
            Simulation, LogContent, Features
        },

        data() {
            return {
                log: null,
                learner: null,
                registration: null,
                simulation: null,
                types: null,
                competencies: null,
                gridCompetencies: null,
                filters: {
                    selectedTypes: [],
                    showCompetencies: false,
                    position1: true,
                    position2: true,
                },
            }
        },

        computed: {

            breadcrumb() {
                let simRoute = this.$permissions.hasRight('dashboard.sessions.read')
                    ? '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/simulations/' + this.$route.params.simulationId + '/learners/' + this.$route.params.learnerId
                    : null

                return [
                    {
                        name: this.learner.name,
                        route: '/astral/ui/dashboard/learners/' + this.$route.params.learnerId
                    },
                    {
                        name: this.registration.degree.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/learners/' + this.$route.params.learnerId
                    },
                    {
                        name: this.simulation.name,
                        route:  simRoute
                    },
                    {
                        name: this.$t('common.log'),
                    },
                ]
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/dashboard/registrations/'+to.params.registrationId+'/simulations/'+to.params.simulationId+'/log',
                { params: {learner_id: to.params.learnerId}}
            )
            .then(resp => {
                next(vm => {
                    vm.log = resp.data.data
                    vm.simulation = resp.data.included.simulation
                    vm.registration = resp.data.included.registration
                    vm.learner = resp.data.included.learner
                    vm.types = resp.data.included.types
                    vm.competencies = resp.data.included.competencies
                    vm.gridCompetencies = resp.data.included.grid_competencies
                    vm.$navigation.setLastSimulation(vm.registration, vm.simulation)
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    Vue.prototype.$loader.hide()
                    next({ name: 'unauthorized' });
                }
            });
        }
    }
</script>
